import React from 'react'

export const RegularForm: React.FC<React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>> = ({
  children,
  ...attributes
}) => {
  // use a `div` instead of `form`, we don't want to ever do browser's formsubmit,
  return <div {...attributes}>{children}</div>
}
